import { useEffect, useState } from 'react';
import { useServerEvent, useCurrentStaffId } from '@maxtropy/components';

// WebSocket 推送消息类型
interface PowerOutageAlarmPushMessage {
  id: number;
}

/**
 * 停电报警推送 Hook
 * 订阅 /ws/power/outage/alarm/{staffId}
 * @param currentAlarmId 当前弹窗显示的报警 ID
 *  - 传入时：仅当推送 id 与 currentAlarmId 一致才触发刷新（详情场景）
 *  - 不传时：收到任意有效推送都触发刷新（列表场景）
 * @returns refreshTrigger - 满足条件时递增，用于触发请求刷新
 */
export function usePowerOutageAlarmRefresh(currentAlarmId?: number) {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const currentStaffId = useCurrentStaffId();

  const [destination, setDestination] = useState<string>();

  useEffect(() => {
    if (currentStaffId) {
      setDestination(`/ws/power/outage/alarm/${currentStaffId}`);
    }
  }, [currentStaffId]);

  const pushMessage = useServerEvent<PowerOutageAlarmPushMessage>(destination);

  useEffect(() => {
    if (!pushMessage?.id) {
      return;
    }

    if (currentAlarmId === undefined || pushMessage.id === currentAlarmId) {
      setRefreshTrigger(prev => prev + 1);
    }
  }, [pushMessage, currentAlarmId]);

  return refreshTrigger;
}
